import { Controller } from "@hotwired/stimulus"

/**
 * Generic toggle controller - shows/hides a content target
 * based on a checkbox or trigger element.
 */
export default class extends Controller {
  static targets = ["content", "invertedContent"]

  toggle(event) {
    const isChecked = event.target.checked
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !isChecked)
    }
    if (this.hasInvertedContentTarget) {
      this.invertedContentTarget.classList.toggle("hidden", isChecked)
    }
  }
}
